import React from 'react';
import { Link } from 'react-router-dom';

class ZeventYearNav extends React.Component {

	render () {
		return (
			<div className="proxima">
				<Link to="/2017">
                    2017
                </Link>
				&nbsp;
                <Link to="/2018">
                    2018
                </Link>
			</div>
		);
	}
}

export default ZeventYearNav;